import  PrmTranslate from '../translate/prmTranslate.module';
import {getAttributesMap} from '../appConfig/appConfigForward';
const angularTranslateModule = require('angular-translate');
require('angular-translate-loader-url');
const dynamicLocale =  require('angular-dynamic-locale');
import {JwtUtilService} from '../security/jwtUtil.service';
import {getInjectableName} from 'ng-metadata/core';
import {I18n} from './I18n.service';
import {getVid} from '../appConfig/appConfigForward';
import appConfigModule from '../appConfig/appConfig.module';

const _get = require('lodash/get');

var angular:angular.IAngularStatic =  require('angular');
export default angular.module('primo-explore.i18n', [
    appConfigModule.name,
    angularTranslateModule,
    dynamicLocale,
    PrmTranslate.name ] )
    .config(configureI18n)
    .run(runI18n)
    .service('I18nService',I18n);

function configureI18n(restBaseURLs, $translateProvider, tmhDynamicLocaleProvider){
    let attributesMap = getAttributesMap();

    if (window.uiLangPrefetch && window.prefetchLang){
        $translateProvider.translations(window.prefetchLang, window.uiLangPrefetch);
    }

    $translateProvider.useUrlLoader(restBaseURLs.translationsUrl+'/'+getVid());
    let lang;
    let langParam = getParameterByName('lang', window.location.search);
    if (langParam){
        var availableLanguages = attributesMap.interfaceLanguageOptions.split(',');
        if (availableLanguages.indexOf(langParam) === -1) {
            lang = attributesMap.interfaceLanguage ? attributesMap.interfaceLanguage : availableLanguages[0];
        } else {
            lang = langParam;
        }
        attributesMap.interfaceLanguage = lang;
        window.appConfig['primo-view']['attributes-map']  =  attributesMap;
    }
    else {
        lang = attributesMap.interfaceLanguage;
    }

    if(lang) {
        $translateProvider.preferredLanguage(lang);
    }




    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');


    $translateProvider.useMissingTranslationHandler('PrmMissingTranslationHandler');
    tmhDynamicLocaleProvider.localeLocationPattern('lib/i18n/angular-locale_{{locale}}.js');

}
configureI18n.$inject = ['restBaseURLs', '$translateProvider', 'tmhDynamicLocaleProvider'];

function runI18n(i18nService, $translate,jwtUtilService, $location, $rootScope: ng.IRootScopeService, $mdDateLocale, $locale: ng.ILocaleService){

    let attributesMap = getAttributesMap();
    let decodedJwt= jwtUtilService.getDecodedToken();
    let lang = attributesMap.interfaceLanguage || '';
    if((jwtUtilService.isSignedIn()) && (decodedJwt.language !== '') && (decodedJwt.language !== $translate.use())){
        lang = decodedJwt.language;
    }
    else if ($location.search().lang && !lang){
            var search = $location.search();
            var availableLanguages = attributesMap.interfaceLanguageOptions.split(',');
            if (availableLanguages.indexOf(search.lang) === -1) {
                search.lang = attributesMap.interfaceLanguage ? attributesMap.interfaceLanguage : availableLanguages[0];
                $location.search(search);
            }
            lang = $location.search().lang;
    }


    if(lang) {
        i18nService.setLanguage(lang);
        i18nService.setPageLanguage(lang);
    }

    $rootScope.$on('$localeChangeSuccess', () => {
        let updatedShortDays: [string] = _get($locale, 'DATETIME_FORMATS.SHORTDAY', []);
        if (updatedShortDays.length){
            $mdDateLocale.shortDays = updatedShortDays;
        }
    });



}
function getParameterByName(name, searchString) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(searchString);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

runI18n.$inject = ['I18nService', '$translate',getInjectableName(JwtUtilService), '$location', '$rootScope', '$mdDateLocale', '$locale'];



// WEBPACK FOOTER //
// ./src/main/webapp/components/i18n/i18n.module.ts